import React from "react";
import ExlyRadioGroup from "repoV2/features/Common/modules/Form/modules/ExlyRadioGroup/ExlyRadioGroup";
import { ISingleSelectOption } from "./ISingleSelectOption.interfaces";

const SingleSelectOption = (props: ISingleSelectOption) => {
    const {
        name,
        title,
        options,
        validator,
        onChange,
        classes = {},
        isRequired,
    } = props;

    return (
        <div className={classes.container}>
            <div className={classes.questionInput}>
                {title}&nbsp;
                {!isRequired && (
                    <span className={classes.optionalQuestionInput}>
                        (Optional)
                    </span>
                )}
            </div>
            <ExlyRadioGroup
                name={name}
                registerOptions={{
                    validate: validator,
                }}
                options={options}
                classes={{
                    helperText: classes.helperText,
                    optionsStyle: classes.optionsStyle,
                }}
                onChange={onChange}
                labelProps={{
                    classes: {
                        label: classes.checkboxLabelText,
                        root: classes.rootCheckboxLabel,
                    },
                }}
                radioProps={{
                    classes: {
                        root: classes.radioButtonStyle,
                    },
                    size: "small",
                }}
            />
        </div>
    );
};

export default SingleSelectOption;
